module.exports = __webpack_public_path__ + "img/d61be0869fd0b9867fd1503d1253815.d7e8291b.jpg";